import { Component, OnInit } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
    selector: 'loading-overlay-search',
    templateUrl: 'products.search.loading.component.html',
    styleUrls: ['./products.component.scss'],
    standalone: true,
    imports: [SvgIconComponent],
})
export class ProductsSearchLoadingComponent implements OnInit {
    private static SHUFFLED_ARRAY_SORT_RANGE: number = 0.5;
    private static START_SLICED_ARRAY: number = 0;
    private static END_SLICED_ARRAY: number = 4;

    originalLoadingIcons: Array<string> = [
        'added-value',
        'blossoming-plants',
        'bouquets',
        'bulb-on-pot',
        'cactus',
        'edible-plants',
        'green-plants',
        'office-planting',
        'orchids',
        'pots',
        'roses',
        'cut-flowers',
        'garden-flowers',
        'tulips',
    ];
    iconArray: Array<string> = [];

    ngOnInit(): void {
        this.getShuffledIcons();
    }

    private getShuffledIcons(): void {
        const shuffled = this.originalLoadingIcons.sort(
            () =>
                ProductsSearchLoadingComponent.SHUFFLED_ARRAY_SORT_RANGE -
                Math.random(),
        );
        this.iconArray = shuffled.slice(
            ProductsSearchLoadingComponent.START_SLICED_ARRAY,
            ProductsSearchLoadingComponent.END_SLICED_ARRAY,
        );
    }
}
